import {Endpoints} from "../Endpoints";
import Backend from "../../Backend";

export default class PurchserUserAPI {
    constructor(token) {
        this.backend = new Backend(token);
    }

    userDetails(callback) {
        this.backend.callBackend(`${Endpoints.purchaser.api.user}`, callback)
    }

    createUser(callback) {
        this.backend.callBackend(`${Endpoints.purchaser.api.user}`, callback, 'POST')
    }

    resetPassword(username, callback) {
        this.backend.callBackend(`${Endpoints.purchaser.api.user}/${username}`, callback, 'PUT')
    }

}